import React, { FC } from 'react';
import BsPagination from 'react-bootstrap/Pagination';

const PAGE_LIMITS = [10, 25, 50, 100];

export interface PaginationMetadata {
  currentPage: number;
  nextPage?: number;
  prevPage?: number;
  totalPages: number;
  totalCount: number;
  limit: number;
  newTablesFlipperEnabled?: boolean;
}

interface PaginationProps extends PaginationMetadata {
  setPage: (page: number) => void;
  setLimit: (limit: number) => void;
}

const Pagination: FC<PaginationProps> = ({
  currentPage,
  nextPage,
  prevPage,
  totalPages,
  limit,
  setPage,
  setLimit,
  newTablesFlipperEnabled = false,
}) => {
  const showPrevControls = currentPage > 1;
  const showNextControls = currentPage < totalPages;
  const prevPagesRange = Array(4)
    .fill(null)
    .map((_, i) => currentPage - (i + 1))
    .filter((i) => i >= 1)
    .sort((a, b) => a - b);
  const nextPagesRange = Array(4)
    .fill(null)
    .map((_, i) => currentPage + (i + 1))
    .filter((i) => i <= totalPages)
    .sort((a, b) => a - b);
  const showPrevEllipsis = currentPage > 5;
  const showNextEllipsis = currentPage < totalPages - 4;

  return (
    <nav className="d-flex align-items-baseline" style={{gap: "20px"}}>
      <BsPagination>
        {showPrevControls && (
          <React.Fragment>
            <BsPagination.First onClick={() => setPage(1)}>
              « First
            </BsPagination.First>
            <BsPagination.Prev onClick={() => setPage(prevPage)}>
              ‹ Prev
            </BsPagination.Prev>
          </React.Fragment>
        )}
        {showPrevEllipsis && <BsPagination.Ellipsis disabled />}
        {prevPagesRange.map((page, idx) => (
          <BsPagination.Item key={idx} onClick={() => setPage(page)}>
            {page}
          </BsPagination.Item>
        ))}
        <BsPagination.Item active>{currentPage}</BsPagination.Item>
        {nextPagesRange.map((page, idx) => (
          <BsPagination.Item key={idx} onClick={() => setPage(page)}>
            {page}
          </BsPagination.Item>
        ))}
        {showNextEllipsis && <BsPagination.Ellipsis disabled />}
        {showNextControls && (
          <React.Fragment>
            <BsPagination.Next onClick={() => setPage(nextPage)}>
              Next ›
            </BsPagination.Next>
            <BsPagination.Last onClick={() => setPage(totalPages)}>
              Last »
            </BsPagination.Last>
          </React.Fragment>
        )}
      </BsPagination>
      {newTablesFlipperEnabled && (
        <div className="dropdown dropend">
          <a
            className="text-decoration-none"
            id="dropdownMenuButton"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            style={{cursor: "pointer"}}
          >
            {limit} per page
            <i className="fa-regular fa-chevron-right ps-1"></i>
          </a>
          <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
            {PAGE_LIMITS.filter((pageLimit) => pageLimit !== limit).map((pageLimit, index, arr) => (
              <React.Fragment key={pageLimit}>
                <li>
                  <span
                    className="dropdown-item fw-normal text-decoration-none pointer"
                    onClick={() => setLimit(pageLimit)}
                    style={{ cursor: "pointer" }}
                  >
                    {pageLimit} per page
                  </span>
                </li>
                {index !== arr.length - 1 && <li><div className="dropdown-divider"></div></li>}
              </React.Fragment>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Pagination;
